<template>
  <ULink
    :active="true"
    class="fixed focus:z-30 bg-white top-0 inset-x-0 h-10 w-full flex justify-center items-center focus-visible:ring-2"
    to="#main"
    >{{ t('accessibility.skipLink') }}</ULink
  >
</template>
